import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  consignmentId: Yup.string().required("Vendor is required."),
  quantity: Yup.number().required("Head is required."),
});
